import { useEffect, useState } from 'react';

import { EnumOption } from '../../modules/types/types';
import httpClient from '../httpClient';

export const useStatusEnvio = () => {
  const [statusEnvio, setStatusEnvio] = useState<EnumOption[]>([]);

  useEffect(() => {
    const fetchStatusEnvio = async () => {
      try {
        const response = await httpClient.get(
          `/api/fornecedorcomunicacao/statusenvio`,
        );

        const options = response.data.map(
          (statusEnvio: { value: number; label: string }) => ({
            value: statusEnvio.value.toString(),
            label: statusEnvio.label,
          }),
        );
        setStatusEnvio(options);
      } catch (error) {
        console.error('Erro ao buscar Status Envio', error);
      }
    };

    fetchStatusEnvio();
  }, []);

  return statusEnvio;
};
